import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index20() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="intro-section pt-lg-2">
    <div className="container">
      <div className="row">
        <div className="col-md-12 col-lg-6">
          <div className="banner banner-big banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-20/banners/banner-1.jpg" alt="Banner" />
            </a>
            <div className="banner-content">
              <h4 className="banner-subtitle text-white"><a href="#">Your Guide To The World</a></h4>{/* End .banner-subtitle */}
              <h2 className="banner-title text-white"><a href="#">Must-Read <br />Travel Books</a></h2>{/* End .banner-title */}
              <a href="#" className="btn btn-outline-white-3 banner-link">Find out more<i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-6 */}
        <div className="col-sm-6 col-lg-3">
          <div className="banner banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-20/banners/banner-2.jpg" alt="Banner" />
            </a>
            <div className="banner-content banner-content-stretch">
              <h4 className="banner-subtitle text-white"><a href="#">New This Week</a></h4>{/* End .banner-subtitle */}
              <h3 className="banner-title text-white"><a href="#">Discover Our <br />Best Romance <br />Books</a></h3>{/* End .banner-title */}
              <a href="#" className="btn btn-outline-white-3 banner-link">Discover Now<i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-3 */}
        <div className="col-sm-6 col-lg-3">
          <div className="banner banner-small banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-20/banners/banner-3.jpg" alt="Banner" />
            </a>
            <div className="banner-content">
              <h4 className="banner-subtitle text-white d-lg-none d-xl-block"><a href="#">Deal Of The Day</a></h4>{/* End .banner-subtitle */}
              <h3 className="banner-title text-white"><a href="#">20% Off Use <br />Code: <span>mybook</span></a></h3>{/* End .banner-title */}
              <a href="#" className="btn btn-outline-white-3 banner-link">Shop Now<i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
          <div className="banner banner-small banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-20/banners/banner-4.jpg" alt="Banner" />
            </a>
            <div className="banner-content">
              <h4 className="banner-subtitle text-white d-lg-none d-xl-block"><a href="#">New Arrivals</a></h4>{/* End .banner-subtitle */}
              <h3 className="banner-title text-white"><a href="#">Business <br />&amp; Economics</a></h3>{/* End .banner-title */}
              <a href="#" className="btn btn-outline-white-3 banner-link">Discover Now<i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-3 */}
      </div>{/* End .row */}
    </div>{/* End .container */}
    <div className="icon-boxes-container bg-transparent">
      <div className="container">
        <div className="row">
          <div className="col-sm-6 col-lg-3">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-truck" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Payment &amp; Delivery</h3>{/* End .icon-box-title */}
                <p>Free shipping for orders over $50</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-3 */}
          <div className="col-sm-6 col-lg-3">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-rotate-left" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Return &amp; Refund</h3>{/* End .icon-box-title */}
                <p>Free 100% money back guarantee</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-3 */}
          <div className="col-sm-6 col-lg-3">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-life-ring" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Quality Support</h3>{/* End .icon-box-title */}
                <p>Alway online feedback 24/7</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-3 */}
          <div className="col-sm-6 col-lg-3">
            <div className="icon-box icon-box-side">
              <span className="icon-box-icon">
                <i className="icon-envelope" />
              </span>
              <div className="icon-box-content">
                <h3 className="icon-box-title">Join Our Newsletter</h3>{/* End .icon-box-title */}
                <p>10% off by subscribing to our newsletter</p>
              </div>{/* End .icon-box-content */}
            </div>{/* End .icon-box */}
          </div>{/* End .col-sm-6 col-lg-3 */}
        </div>{/* End .row */}
      </div>{/* End .container */}
    </div>{/* End .icon-boxes-container */}
  </div>{/* End .intro-section */}
  <div className="bestseller-products bg-light pt-5 pb-5 mb-5">
    <div className="block">
      <div className="block-wrapper ">
        <div className="container">
          <div className="heading heading-flex">
            <div className="heading-left">
              <h2 className="title">Bestsellers</h2>{/* End .title */}
            </div>{/* End .heading-left */}
            <div className="heading-right">
              <a href="category.html" className="title-link">View more Products <i className="icon-long-arrow-right" /></a>
            </div>{/* End .heading-right */}
          </div>{/* End .header-flex */}
          <div className="owl-carousel carousel-equal-height owl-simple" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;480&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1440&quot;: {
                          &quot;items&quot;:5
                      }
                  }
              }">
            <div className="product">
              <span className="product-label label-sale">Sale</span>
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-1.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">Michelle Obama</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Becoming</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">$19.50</span>
                  <span className="old-price">Was $32.50</span>
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 10 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-2.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">Jordan B. Peterson</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">The Secret Barrister: Stories <br />of the Law and How It's ...</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $17.34
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 7 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <span className="product-label label-sale">Sale</span>
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-3.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">Rachael Lippincott</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Five Feet Apart</a></h3>{/* End .product-title */}
                <div className="product-price">
                  <span className="new-price">$14.95</span>
                  <span className="old-price">Was $18.99</span>
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 6 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-4.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">Karen M. McManus </a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">One of Us Is Lying</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $17.99
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 10 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-5.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">Matt Haig</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">How to Stop Time</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $11.68
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 10 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-6.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">John Gray</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">The Durrells of Corfu: Exclusive Edition</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $24.48
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 10 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .owl-carousel */}
        </div>{/* End .container */}
      </div>{/* End .block-wrapper */}
    </div>{/* End .block */}
  </div>{/* End .bg-light pt-4 pb-4 */}
  <div className="container">
    <div className="heading heading-flex">
      <div className="heading-left">
        <h2 className="title">New Releases</h2>{/* End .title */}
      </div>{/* End .heading-left */}
      <div className="heading-right">
        <a href="category.html" className="title-link">View more Products <i className="icon-long-arrow-right" /></a>
      </div>{/* End .heading-right */}
    </div>{/* End .header-flex */}
    <div className="row">
      <div className="col-xl-4">
        <div className="owl-carousel carousel-equal-height owl-simple" data-toggle="owl" data-owl-options="{
              &quot;nav&quot;: false, 
              &quot;dots&quot;: true,
              &quot;margin&quot;: 10
          }">
          <div className="product-big">
            <img src="asset/images/demos/demo-20/products/product-big-1-bg.jpg" alt="product bg img" />
            <div className="product-wrap">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-big-1.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">Becky Albertalli</a> and <a href="#">Adam Silvera</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">What If <br />It's Us.</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $18.99
                </div>{/* End .product-price */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product-body */}
            </div>{/* End .product-wrap */}
          </div>{/* End .product-big */}
          <div className="product-big">
            <img src="asset/images/demos/demo-20/products/product-big-2-bg.jpg" alt="product bg img" />
            <div className="product-wrap">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-12.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">Nicola Yoon </a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">The Sun Is Also a Star.</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $10.99
                </div>{/* End .product-price */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product-body */}
            </div>{/* End .product-wrap */}
          </div>{/* End .product-big */}
        </div>{/* End .owl-carousel */}
        <div className="mb-3 d-xl-none" />{/* End .mb-3 d-none */}
      </div>{/* End .col-lg-4 */}
      <div className="col-xl-8">
        <div className="block-wrapper ">
          <div className="owl-carousel carousel-equal-height owl-simple" data-toggle="owl" data-owl-options="{
                  &quot;nav&quot;: false, 
                  &quot;dots&quot;: true,
                  &quot;margin&quot;: 20,
                  &quot;loop&quot;: false,
                  &quot;responsive&quot;: {
                      &quot;0&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;480&quot;: {
                          &quot;items&quot;:2
                      },
                      &quot;768&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;992&quot;: {
                          &quot;items&quot;:4
                      },
                      &quot;1200&quot;: {
                          &quot;items&quot;:3
                      },
                      &quot;1440&quot;: {
                          &quot;items&quot;:4
                      }
                  }
              }">
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-6.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">John Gray</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">The Durrells of Corfu: Exclusive Edition</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $24.48
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 5 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-7.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">John Gray</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">The Moon: A History for the Future </a></h3>{/* End .product-title */}
                <div className="product-price">
                  $16.97
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 5 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-8.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">John Gray</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">Hard Pushed: A Midwife's Story</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $12.99
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 4 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
            <div className="product">
              <figure className="product-media">
                <a href="product.html">
                  <img src="asset/images/demos/demo-20/products/product-9.jpg" alt="Product image" className="product-image" />
                </a>
              </figure>{/* End .product-media */}
              <div className="product-body">
                <div className="product-cat">
                  by <a href="#">John Gray</a>
                </div>{/* End .product-cat */}
                <h3 className="product-title"><a href="product.html">This Lie Will Kill You</a></h3>{/* End .product-title */}
                <div className="product-price">
                  $7.99
                </div>{/* End .product-price */}
                <div className="product-footer">
                  <div className="ratings-container">
                    <div className="ratings">
                      <div className="ratings-val" style={{width: '0%'}} />{/* End .ratings-val */}
                    </div>{/* End .ratings */}
                    <span className="ratings-text">( 0 Reviews )</span>
                  </div>{/* End .rating-container */}
                  <div className="product-action">
                    <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                    <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                  </div>{/* End .product-action */}
                </div>{/* End .product-footer */}
              </div>{/* End .product-body */}
            </div>{/* End .product */}
          </div>{/* End .owl-carousel */}
        </div>{/* End .block-wrapper */}
      </div>{/* End .col-lg-8 */}
    </div>{/* End .row */}
  </div>{/* End .container */}
  <div className="mb-5" />{/* End .mb-3 */}
  <div className="banner-group mb-2">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="banner banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-20/banners/banner-6.jpg" alt="Banner" />
            </a>
            <div className="banner-content">
              <h4 className="banner-subtitle text-white"><a href="#">A Perfect Choice For Your Children</a></h4>{/* End .banner-subtitle */}
              <h3 className="banner-title text-white"><a href="#">Children's <br />Bestselling Books</a></h3>{/* End .banner-title */}
              <a href="#" className="btn btn-outline-white-3 banner-link">Discover Now<i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-4 */}
        <div className="col-md-6 col-lg-4">
          <div className="banner banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-20/banners/banner-7.jpg" alt="Banner" />
            </a>
            <div className="banner-content">
              <h4 className="banner-subtitle text-white"><a href="#">Mental Health Awareness Week</a></h4>{/* End .banner-subtitle */}
              <h3 className="banner-title text-white"><a href="#">Self-Help For <br />Your Future.</a></h3>{/* End .banner-title */}
              <a href="#" className="btn btn-outline-white-3 banner-link">Discover Now<i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-4 */}
        <div className="col-md-6 col-lg-4">
          <div className="banner banner-overlay">
            <a href="#">
              <img src="asset/images/demos/demo-20/banners/banner-8.jpg" alt="Banner" />
            </a>
            <div className="banner-content">
              <h4 className="banner-subtitle text-white"><a href="#">New York Times Bestsellers</a></h4>{/* End .banner-subtitle */}
              <h3 className="banner-title text-white"><a href="#">Bestselling Food <br />and Drink Books.</a></h3>{/* End .banner-title */}
              <a href="#" className="btn btn-outline-white-3 banner-link">Discover Now<i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>{/* End .col-lg-4 */}
      </div>{/* End .row */}
    </div>{/* End .container */}
  </div>{/* End .banner-group */}
  <div className="block">
    <div className="block-wrapper ">
      <div className="container">
        <div className="heading heading-flex">
          <div className="heading-left">
            <h2 className="title">Picks From Our Experts</h2>{/* End .title */}
          </div>{/* End .heading-left */}
          <div className="heading-right">
            <a href="category.html" className="title-link">View more Products <i className="icon-long-arrow-right" /></a>
          </div>{/* End .heading-right */}
        </div>{/* End .header-flex */}
        <div className="owl-carousel carousel-equal-height owl-simple" data-toggle="owl" data-owl-options="{
              &quot;nav&quot;: false, 
              &quot;dots&quot;: true,
              &quot;margin&quot;: 20,
              &quot;loop&quot;: false,
              &quot;responsive&quot;: {
                  &quot;0&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;480&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;768&quot;: {
                      &quot;items&quot;:3
                  },
                  &quot;992&quot;: {
                      &quot;items&quot;:4
                  },
                  &quot;1200&quot;: {
                      &quot;items&quot;:5
                  },
                  &quot;1440&quot;: {
                      &quot;items&quot;:6
                  }
              }
          }">
          <div className="product">
            <span className="product-label label-sale">Sale</span>
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-20/products/product-10.jpg" alt="Product image" className="product-image" />
              </a>
            </figure>{/* End .product-media */}
            <div className="product-body">
              <div className="product-cat">
                by <a href="#">John Gray</a>
              </div>{/* End .product-cat */}
              <h3 className="product-title"><a href="product.html">Normal People</a></h3>{/* End .product-title */}
              <div className="product-price">
                <span className="new-price">$6.99</span>
                <span className="old-price">Was $10.99</span>
              </div>{/* End .product-price */}
              <div className="product-footer">
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 5 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product-footer */}
            </div>{/* End .product-body */}
          </div>{/* End .product */}
          <div className="product">
            <span className="product-label label-sale">Sale</span>
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-20/products/product-11.jpg" alt="Product image" className="product-image" />
              </a>
            </figure>{/* End .product-media */}
            <div className="product-body">
              <div className="product-cat">
                by <a href="#">John Gray</a>
              </div>{/* End .product-cat */}
              <h3 className="product-title"><a href="product.html">The Silence of the Girls</a></h3>{/* End .product-title */}
              <div className="product-price">
                <span className="new-price">$6.99</span>
                <span className="old-price">Was $9.99</span>
              </div>{/* End .product-price */}
              <div className="product-footer">
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 7 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product-footer */}
            </div>{/* End .product-body */}
          </div>{/* End .product */}
          <div className="product">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-20/products/product-12.jpg" alt="Product image" className="product-image" />
              </a>
            </figure>{/* End .product-media */}
            <div className="product-body">
              <div className="product-cat">
                by <a href="#">John Gray</a>
              </div>{/* End .product-cat */}
              <h3 className="product-title"><a href="product.html">You Got This</a></h3>{/* End .product-title */}
              <div className="product-price">
                $7.99
              </div>{/* End .product-price */}
              <div className="product-footer">
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '60%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 6 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product-footer */}
            </div>{/* End .product-body */}
          </div>{/* End .product */}
          <div className="product">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-20/products/product-1.jpg" alt="Product image" className="product-image" />
              </a>
            </figure>{/* End .product-media */}
            <div className="product-body">
              <div className="product-cat">
                by <a href="#">John Gray</a>
              </div>{/* End .product-cat */}
              <h3 className="product-title"><a href="product.html">The Librarian of <br />Auschwitz</a></h3>{/* End .product-title */}
              <div className="product-price">
                $10.99
              </div>{/* End .product-price */}
              <div className="product-footer">
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '0%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 0 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product-footer */}
            </div>{/* End .product-body */}
          </div>{/* End .product */}
          <div className="product">
            <span className="product-label label-sale">Sale</span>
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-20/products/product-14.jpg" alt="Product image" className="product-image" />
              </a>
            </figure>{/* End .product-media */}
            <div className="product-body">
              <div className="product-cat">
                by <a href="#">John Gray</a>
              </div>{/* End .product-cat */}
              <h3 className="product-title"><a href="product.html">Moneyland: Why Thieves And Crooks Now Rule ...</a></h3>{/* End .product-title */}
              <div className="product-price">
                <span className="new-price">$7.99</span>
                <span className="old-price">Was $12.99</span>
              </div>{/* End .product-price */}
              <div className="product-footer">
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '100%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 13 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product-footer */}
            </div>{/* End .product-body */}
          </div>{/* End .product */}
          <div className="product">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-20/products/product-2.jpg" alt="Product image" className="product-image" />
              </a>
            </figure>{/* End .product-media */}
            <div className="product-body">
              <div className="product-cat">
                by <a href="#">John Gray</a>
              </div>{/* End .product-cat */}
              <h3 className="product-title"><a href="product.html">This is Going to Hurt: Secret Diaries of a Juni</a></h3>{/* End .product-title */}
              <div className="product-price">
                $12.00
              </div>{/* End .product-price */}
              <div className="product-footer">
                <div className="ratings-container">
                  <div className="ratings">
                    <div className="ratings-val" style={{width: '80%'}} />{/* End .ratings-val */}
                  </div>{/* End .ratings */}
                  <span className="ratings-text">( 4 Reviews )</span>
                </div>{/* End .rating-container */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                  <a href="#" className="btn-product btn-wishlist"><span>Add to Wishlist</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product-footer */}
            </div>{/* End .product-body */}
          </div>{/* End .product */}
        </div>{/* End .owl-carousel */}
      </div>{/* End .container */}
    </div>{/* End .block-wrapper */}
  </div>{/* End .block */}
  <div className="mb-5" />{/* End .mb-5 */}
  <div className="blog-posts bg-light pt-4 pb-4">
    <div className="container">
      <h2 className="title">From Our Blog</h2>{/* End .title-lg text-center */}
      <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: true,
          &quot;items&quot;: 3,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:1
              },
              &quot;600&quot;: {
                  &quot;items&quot;:2
              },
              &quot;992&quot;: {
                  &quot;items&quot;:3
              },
              &quot;1200&quot;: {
                  &quot;items&quot;:4
              }
          }
      }">
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-20/blog/post-1.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Aenean dignissim pellentesque felis.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Morbi in sem quis dui placerat ornare. Pellentesque odio nisi, euismod in, pharetra a, ultricies in, diam. Sed arcu. </p>
              <a href="single.html" className="read-more">Continue read ...</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-20/blog/post-2.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Dec 12, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Donec nec justo eget felis facilisis fermentum.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut Suspendisse urna nibh, viverra non, semper suscipit. </p>
              <a href="single.html" className="read-more">Continue read ...</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-20/blog/post-3.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Dec 19, 2018</a>, 2 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Aliquam porttitor mauris sit.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Suspendisse urna nibh, viverra semper suscipit. posuere a, pede. Morbi in sem quis dui placerat ornare. </p>
              <a href="single.html" className="read-more">Continue read ...</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/demos/demo-20/blog/post-4.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body">
            <div className="entry-meta">
              <a href="#">Dec 19, 2018</a>, 2 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Integer vitae libero ac risus egestas placerat.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Lorem ipsum dolor sit amet, consecte tuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. </p>
              <a href="single.html" className="read-more">Continue read ...</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
      </div>{/* End .owl-carousel */}
    </div>{/* End .container */}
  </div>{/* End .blog-posts */}
  <div className="cta-newsletter text-center pt-6 pb-7">
    <div className="container">
      <span className="cta-icon"><i className="icon-envelope" /></span>
      <h3 className="title">Subscribe for Our Newsletter</h3>{/* End .title */}
      <p className="title-desc">Learn about new offers and get more deals by joining our newsletter</p>{/* End .title-desc */}
      <form action="#">
        <div className="input-group">
          <input type="email" className="form-control" placeholder="Enter your Email Address" aria-label="Email Adress" aria-describedby="newsletter-btn" required />
          <div className="input-group-append">
            <button className="btn btn-primary" type="submit" id="newsletter-btn"><span>SUBSCRIBE</span><i className="icon-long-arrow-right" /></button>
          </div>{/* .End .input-group-append */}
        </div>{/* .End .input-group */}
      </form>
    </div>{/* End .container */}
  </div>{/* End .cta-newsletter */}
</main>

        <UserFooter/>
    </div>
  )
}

export default Index20